import api from '../api';

const baseContext = `${process.env.REACT_APP_API_URL_LOCAL}/api/v1/worker/user`;

export enum WORKER_STATUS {
  'needInformation' = 'needInformation',
  'rejected' = 'rejected',
  'waitingRevision' = 'waitingRevision',
  'enabled' = 'enabled',
  'suspended' = 'suspended',
}

export interface User {
  id: string;
  birthday: Date;
  firstName: string;
  code: string;
  lastName: string;
  imageURL: string;
  email: string;
  phoneNumber: string;
  documentTypeId: string;
  documentNumber: string;
  educationLevelId: string;
  worksSince: Date;
  cityId: string;
  address: string;
  locationLat: number;
  locationLong: number;
  workFieldIds: string[];
  hasChanges: boolean;
  termns: string;
  state: WORKER_STATUS;
  files: {
    file: string;
    blob: Blob;
  }[];
}

export type TLogin = {
  email: string;
  lastName: string;
  firstName: string;
};

const registrationRequest = ({ files, ...rest }: User) => {
  const formData = new FormData();
  formData.append('json', JSON.stringify(rest));
  files
    .filter(({ blob }) => blob instanceof Blob)
    .forEach(({ file, blob }) => formData.append(file, blob));
  return api.post(`${baseContext}/registrationRequest`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};
const updateUserInfo = (data: User) => {
  return api.put(`${baseContext}/update`, data);
};
const getUser = (email: string) => {
  return api.post(`${baseContext}/login`, { email });
};
const login = ({ email, lastName, firstName }: TLogin) => {
  return api.post(`${baseContext}/login`, { email, lastName, firstName });
};

export { registrationRequest, updateUserInfo, getUser, login };
